<template>
  <v-main>
    <RowDetailsDialog ref="detailsDialog" />

    <ORow top>
      <OCol class="oderon-col-4 pa-2 children-pa-2">
        <div>
          <PendingChecklists @rowClicked="showRowDetails" />
        </div>
        <div>
          <Filas />
        </div>
      </OCol>
      <OCol class="oderon-col-8 pa-2 children-pa-2">
        <div>
          <ProblemasAbertos @rowClicked="showRowDetails" />
        </div>
        <div>
          <ProblemasTratativas @rowClicked="showRowDetails" />
        </div>
      </OCol>
    </ORow>
  </v-main>
</template>

<script>
import RowDetailsDialog from '../../installed-base/RowDetailsDialog.vue'
import Filas from './Filas.vue'
import PendingChecklists from './PendingChecklists.vue'
import ProblemasAbertos from './ProblemasAbertos.vue'
import ProblemasTratativas from './ProblemasTratativas.vue'
import { getStandaloneUrl } from './utils'

export default {
  pageTitle: 'Saúde da Base Instalada',
  components: {
    RowDetailsDialog,
    PendingChecklists,
    ProblemasAbertos,
    ProblemasTratativas,
    Filas
  },
  methods: {
    showRowDetails({ row, isMiddle }) {
      if (isMiddle) {
        window.open('/#' + getStandaloneUrl(row), '_blank')
      } else {
        this.$refs.detailsDialog.open(row.id)
      }
    }
  }
}
</script>

<style></style>
